import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { getChartTypeSettings, type ChartTypeSettings } from '../services/chartTypeService'

export function resolveChartType(cfg: ChartTypeSettings | null, isMaster: boolean): 'default' | 'tv_v2' {
  if (!cfg) return 'default'
  if (cfg.activeType !== 'tv_v2') return 'default'
  if (isMaster) return cfg.enabledForMaster ? 'tv_v2' : 'default'
  return cfg.enabledForUsers ? 'tv_v2' : 'default'
}

export function useChartType() {
  const { profile } = useAuth()
  const isMaster = (profile?.role === 'master')
  const [loading, setLoading] = React.useState(true)
  const [cfg, setCfg] = React.useState<ChartTypeSettings | null>(null)

  React.useEffect(() => {
    let active = true
    getChartTypeSettings()
      .then((c) => { if (active) setCfg(c) })
      .catch(() => { if (active) setCfg(null) })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [])

  const activeType = React.useMemo(() => resolveChartType(cfg, isMaster), [cfg, isMaster])
  const shouldUseV2 = activeType === 'tv_v2'

  return { loading, config: cfg, isMaster, activeType, shouldUseV2 }
}

